import { useEffect, useState } from "react";
import { Button, Popover, Segmented, Select } from "../components/rumonai";
import { PRESETS, useAppearance, type Theme } from "../lib/appearance";
import { Avatar } from "./Avatar";
import "./AccountMenu.css";

const THEMES = [
  { value: "system", label: "跟随系统" },
  { value: "light", label: "浅色" },
  { value: "dark", label: "深色" },
];

/** Account identity, shared appearance preferences and the existing sign-out action. */
export function AccountMenu({ name, credit, onLogout }: { name: string; credit?: string; onLogout?: () => void }) {
  const [open, setOpen] = useState(false);
  const [container, setContainer] = useState<HTMLDivElement | null>(null);
  const { value, onChange } = useAppearance();
  const mode = value.theme === "system" ? (window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light") : value.theme;
  useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener("hashchange", close);
    return () => window.removeEventListener("hashchange", close);
  }, []);
  return <div className="owner-account" ref={setContainer}>
    <Popover open={open} onOpenChange={setOpen} label="账号菜单" side="top" portalContainer={container}
      trigger={<button type="button" className="owner-account-row" title="账号与外观">
        <Avatar name={name} size="lg" glyph="person" />
        <span className="owner-account-text"><b data-quoted="true">{name}</b>{credit ? <small className="num">可用 {credit}</small> : null}</span>
      </button>}>
      <div className="owner-account-controls">
        <a className="pa-menu-item" href="/#/settings?section=workspace" onClick={() => setOpen(false)}>账号与额度</a>
        <a className="pa-menu-item" href="/#/people" onClick={() => setOpen(false)}>身份与聊天权限</a>
        <p className="pa-menu-label">外观</p>
        <Segmented label="显示模式" value={value.theme} onValueChange={theme => onChange({ ...value, theme: theme as Theme })} items={THEMES} />
        <Select label="配色" value={value[mode]} portalContainer={container}
          items={PRESETS.map(preset => ({ value: preset.id, label: preset.name }))}
          onValueChange={id => { const preset = PRESETS.find(item => item.id === id); if (preset) onChange({ ...value, [preset.mode]: preset.id, theme: preset.mode }); }} />
        {onLogout ? <Button variant="ghost" icon="logout" onClick={() => { setOpen(false); onLogout(); }}>退出登录</Button> : null}
      </div>
    </Popover>
  </div>;
}
